import React, {FC, MouseEvent, useState, useEffect, ChangeEvent}  from 'react';
import {useParams} from 'react-router';
import { useNavigate } from 'react-router-dom';

// import MUI.
import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, MenuItem, IconButton, Checkbox} from '@mui/material';
import {Menu as MenuIcon, AccountCircle as AccountCircleIcon, 
  Home as HomeIcon, ManageAccounts as ManageAccountsIcon, Logout as LogoutIcon } from '@mui/icons-material';
  import AddCircleIcon from '@mui/icons-material/AddCircle';
// import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';
import {useQuery,useQueryClient, QueryClient, QueryClientProvider, useMutation, } from "react-query";
import { useSnackbar } from 'notistack';
import { useTranslation  } from 'react-i18next';

// import user Component
import EnhancedTable, {EnhancedTableProps, EnhancedTableToolbarProps } from '../../ui/EnhancedTable';
import ArrayFieldTable, {HeadCell} from '../../ui/ArrayFieldTable';

import {FormDialog} from '../../ui/FormDialog';
import BasicSelectList from '../../ui/BasicSelectList';

// import user Library.
import IBankRole, {IBankRoleItem, defaultBankRole, IFormDef, IFormAction} from './model/BankRole';
import useBankRoleService from './service/BankRole';

import {useUserStore} from '../../library/store'; 



const BankRoleForm: FC<IBankRole> = (props: IBankRole = defaultBankRole) => {

    const {roleItems} = props;
    const { setCurrentEntity,currentUser,setIsBackendOperation, setCurrentObjectDataDef, setCurrentObjectKey } = useUserStore();
    const {language: lg} = currentUser;
    const navigate = useNavigate();

    const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const {roleID} = useParams();    

    const [_roleID, _setRoleID] = useState<number>( Number( roleID || 0 ) );

    const methods = useForm<IBankRole>( {defaultValues:defaultBankRole} );

    const { register, setValue ,getValues,reset ,control , formState: { errors } } = methods;

    let {fields, append, remove, update} = useFieldArray<IBankRole,'roleItems'>({
      control, 
      name: 'roleItems'});

    const  {getFormsList, getRolesList, saveBankRole, getBankRole} = useBankRoleService();

    const {isSuccess: isBankRoleItemsSuccess, status: bankRoleItemStatus,data: forms} = useQuery<IFormDef[]>("formDef",getFormsList);
    const [openFormList, setOpenFormList] = useState(false);
    const [selectedForms, setSelectedForms] = useState<string[]>([]);

    const {isSuccess: isRolesSuccess, status: rolesStatus,data: roles} = useQuery<IBankRole[]>("roles",getRolesList);
    const [openRoleList, setOpenRoleList] = useState(false);

    const queryClient = useQueryClient();
    const {isLoading, isError, isSuccess ,error,mutate } = useMutation<IBankRole,Error,IBankRole>(saveBankRole, 
      {        
        onSuccess: (data: IBankRole) => {
          enqueueSnackbar( t('_Operation_done'), { variant: 'success',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 }); 
            
          //reset(data);
          setValue('roleID', data.roleID);
          queryClient.invalidateQueries(['BankRole',data.roleID]);
          queryClient.invalidateQueries('roles');
        },
        onError: (err: Error) => {          
          enqueueSnackbar( 'error', { variant: 'error',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
        }
      });     


    const {data: _data} = useQuery<IBankRole>(['BankRole', _roleID], () => getBankRole( _roleID  ), 
      {enabled: _roleID > 0 } );

    useEffect( () => {
      setCurrentEntity(t('BankRole'));
      setCurrentObjectDataDef('10030'); //
      setCurrentObjectKey( _roleID<=0? '':_roleID.toString());
      
      if( currentUser.userMenus.find( x => x.entity === 'BankRole') === undefined)
        navigate('/');
    }, [_roleID] );

    useEffect( () => { 
      const data = getValues();
      const tmpRoleID = data.roleID || 0;
      
      if(tmpRoleID !== _roleID) {
        reset(_data);
      }

      
    }, [_data, reset]);

    useEffect( () => {
      setIsBackendOperation(isLoading);
    }, [isLoading]);

    //useEffect( () => {setCurrentEntity('BankRole');}, [] );

    // useEffect( () => { 
    //   //console.log(headCells);
    //   //setColumnWith(headCells, rows);
    //   //console.log(headCells);
    //   {fields} = useFieldArray({control, name: 'roleItems' });
    // }, []);

    // : HeadCell<BankRoleItem>[]
    const [headRoleItemCells, setHeadRoleItemCells]  = useState<HeadCell<IBankRoleItem>[]>([
      //{id:'formCode', label : 'Code',  display: true, type: 'string'},
      {id:'formName', label : t('Name'),  display: true, type: 'string'},
      {id:'canCreate', label : t('Create'),  display: true, type: 'boolean'},
      {id:'canRetreive', label : t('Retreive'),  display: true, type: 'boolean'},
      {id:'canUpdate', label : t('Update'),  display: true, type: 'boolean'},
      {id:'canPrint', label : t('Print'),  display: true, type: 'boolean'},
      {id:'canMergeDoc', label : t('MergeDoc'),  display: true, type: 'boolean'},
      {id:'canAttachDoc', label : t('AttachDoc'),  display: true, type: 'boolean'},
      {id:'canWorkflow', label : t('Workflow'),  display: true, type: 'boolean'},
      {id:'canAuthorize', label : t('Authorize'),  display: true, type: 'boolean'},
  ]);

  const [headRoleCells, setHeadRoleCells]  = useState<HeadCell<IBankRole>[]>([
    {id:'roleID', label : t('ID'),  display: true, type: 'string'},
    {id:'roleName', label : t('Name'),  display: true, type: 'string'},
    {id:'roleDescription', label : t('Description'),  display: true, type: 'string'},    
]);


    const handleAddRoleItem = (event : any) => {
      setOpenFormList(true);      
    }

    const handleOkFormList = () => {
      
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      

      //alert(selectedForms.length);
      setOpenFormList(false);

      if(forms && roleItems && selectedForms.length > 0) {
        const arr = forms.filter( x => selectedForms.includes(x.formCode));

        //console.log(arr);

        append( arr.map( f => ({...f, canCreate: false, canRetreive:false, canUpdate: false, canDelete: false,
          canPrint: false, canMergeDoc: false, canAttachDoc: false, canWorkflow: false, canAuthorize: false, formActions: []} )) );


          // handleSubmit((data) => {
          //   //alert(JSON.stringify(data))
          //   console.log(data);
          // });
        //const f = arr[0];
        // append( {formCode: '', formName: '' , canCreate: false, canRetreive:false, canUpdate: false, canDelete: false,
        //   canPrint: false, canMergeDoc: false, canAttachDoc: false, canWorkflow: false, canAuthorize: false, formAction: []});

        // arr.forEach( f => roleItems.push({...f, canCreate: false, canRetreive:false, canUpdate: false, canDelete: false,
        //         canPrint: false, canMergeDoc: false, canAttachDoc: false, canWorkflow: false, canAuthorize: false, formAction: []}) );
        //roleItems.push( arr.map(f => (  {...f, })) );
        
        
      }

      //roleItems?.push();
    }

    const [currentFormSelected, setCurrentFormSelected] = useState<IFormDef>();
    const [currentFormActionsInit, setCurrentFormActionsInit] = useState<string[]>([]);
    // Here field is the current role item object selected... 
    //const handleRoleItemSelected = (event: React.MouseEvent<unknown>, field: FieldArrayWithId<IBankRole, ArrayPath<IBankRole>>) => {
    const handleRoleItemSelected = (event: React.MouseEvent<unknown>, index: number ,field: IBankRoleItem) => {
      if(forms) {        
        const form = forms.find(x => x.formCode === field.formCode );
        if(form != null) {
          setCurrentFormSelected(form);
          
          setCurrentFormActionsInit(field.formActions.map(fa => fa.name) );
         
          //field.formActions
        }        
      }      
    }

    //const handleActionCheckedChange = (event: ChangeEvent<HTMLInputElement>,checked: boolean, item: IFormAction ) => {
    const handleActionCheckedChange = (checked: boolean, item: IFormAction ) => {
      // console.log(currentFormSelected);
      if(currentFormSelected === null || currentFormSelected === undefined) return;

      const bankRoleItem = fields.find( x => x.formCode === currentFormSelected?.formCode);
      const index = fields.findIndex(x => x.formCode === currentFormSelected?.formCode);
      // console.log(checked);
      // console.log(bankRoleItem);
      

      if(bankRoleItem != null) {
        if(checked)
          bankRoleItem.formActions.push(item);
        else
          bankRoleItem.formActions = bankRoleItem.formActions.filter(x => x.name !== item.name );
        
        bankRoleItem.formAction = bankRoleItem.formActions.map(fa => fa.name).join(':');
        console.log(bankRoleItem);
        update(index, bankRoleItem);
      }
    }

    const handleBankRoleRowDoubleClick = (event: React.MouseEvent<unknown>, bankRole: IBankRole) => {
      setOpenRoleList(false);
      const selectedRoleID = bankRole.roleID || 0;
      
      if(selectedRoleID > 0) 
        _setRoleID(selectedRoleID);
    }

    
    const saveData = async (event: MouseEvent<HTMLButtonElement>) => {

      const data = getValues();
      
      mutate(data);
    }

    const listData = async (event: MouseEvent<HTMLButtonElement>) => {
      //navigate('bankRoleList');
      setOpenRoleList(true);
    }

    return (
      <>
        <FormProvider {...methods} >
          <Grid container component="main" sx={{  width: '100%' }} alignItems="flex-start">
            <Grid item xs={12}  component={Paper} elevation={0} >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                  <Box sx={{ mt: 1, width: '100%' }} >
                      <TextField  sx={{width: 'calc(15% - 8px)'}} id="roleID" label={t('ID')} {...register('roleID')} disabled />                    
                      <TextField  sx={{width:'calc(35% - 8px)'}} id="roleName" label={t('Name')} {...register('roleName')}  />                    
                      <TextField  sx={{width:'calc(50% - 8px)'}}  id="roleDescription" label={t('Description')} {...register('roleDescription')} />
                      <Button id='btnSave' onClick={saveData} sx={ {display:'none'}}  />
                      <Button id='btnList' onClick={listData} sx={ {display:'none'}}  />
                  </Box>                
              </Box>            
            </Grid>   
            <Grid item container xs={12}  component={Paper} elevation={0} direction="column">
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', width: '100%' }} >
                  <Box sx={{ mt: 1, width: '80%' }} >
                      {/* <EnhancedTable headCells={headRoleItemCells} numSelected={numSelected} rowCount={10} rows={roleItems?roleItems:[]}
                      order='asc' orderBy='formCode' objKey='formCode' 
                      toolbarActions={[ { toolTip: 'Add..', onClickIcon: handleAddRoleItem ,icon: HomeIcon } ]} /> */}
                      <ArrayFieldTable<IBankRole,IBankRoleItem,"id"> mainObject={getValues()} headCells={headRoleItemCells} 
                          rowsPathName='roleItems' fieldKey='formCode'
                          onRowSelected={handleRoleItemSelected}
                          toolbarActions={[ { toolTip: 'Add..', onClickIcon: handleAddRoleItem ,icon: AddCircleIcon } ]} />                  
                  </Box>    
                  <Box sx={{ mt: 1, width: '20%' }} >
                    {currentFormSelected && <BasicSelectList  items={currentFormSelected.formActions} title='Actions'
                        valueKey='name' displayKey='description' initialItemsSelected={currentFormActionsInit}
                        onItemCheckedChange={handleActionCheckedChange}  /> }
                  </Box>            
              </Box>            
            </Grid>

            <Grid item container xs={12}  component={Paper} elevation={0} direction="column">
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }} >                 
                  <Box sx={{ mt: 1, width: '80%' }} >
                    {/* {fields.map( (item, index) => {

                        return (                           
                        <>
                          <Controller
                            name={`roleItems.${index}.formCode`} control={control}
                            render={ ({field}) => <TextField {...field}  /> }
                          />
                          <Controller
                            name={`roleItems.${index}.canCreate`} control={control}
                            //defaultValue={false}                            
                            render={({ field }) => <Checkbox {...field} />}
                          />                        
                        </>);
                    } )
                    } */}
                  </Box>    
                  <Box sx={{ mt: 1, width: '20%' }} >
                      
                  </Box>            
              </Box>            
            </Grid>
          </Grid>
          
          { openFormList && <FormDialog open={openFormList} maxWidth='sm'
            okText='OK' cancelText={t('Cancel')} title={t('Select Functionalities')} onCancel={()=> {setOpenFormList(false);}} 
            onClose={()=> {setOpenFormList(false);}} onOk={handleOkFormList}  >
            <Box sx={{ mt: 1, width: '100%' }} >
              {forms && <BasicSelectList  items={forms.filter(f => !getValues().roleItems.some(x => x.formCode === f.formCode))} 
                valueKey='formCode' displayKey='formName' setSelectedItems={setSelectedForms} title={t('Functionalities')} /> }
            </Box>
          </FormDialog> }
          { openRoleList && <FormDialog open={openRoleList} okText='OK' cancelText={t('Cancel')} title={t('Select Role')} maxWidth='md'
            onCancel={()=> {setOpenRoleList(false);}} 
            onClose={()=> {setOpenRoleList(false);}} onOk={handleOkFormList}  >
            <Box sx={{ mt: 1, width: '100%' }} >
              {roles && <EnhancedTable<IBankRole>  rows={roles} headCells={headRoleCells} 
                  order='asc' orderBy='roleName'
                  title={t('Roles')} objKey='roleID'
                  onRowDoubleClick={handleBankRoleRowDoubleClick}/> }
            </Box>
          </FormDialog> }
        </FormProvider>
      </>
    );
  }


  BankRoleForm.defaultProps = defaultBankRole;
  
  export default BankRoleForm;